// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.spacer {
  width: 100%;
}
@media screen and (min-width: 0px) {
  .spacer {
    height: 20px;
  }
}
@media screen and (min-width: 667px) {
  .spacer {
    height: 30px;
  }
}
@media screen and (min-width: 900px) {
  .spacer {
    height: 80px;
  }
}
@media screen and (min-width: 1200px) {
  .spacer {
    height: 100px;
  }
}

.headline-image {
  object-fit: contain;
  max-width: 1080px;
  width: 100%;
}

.headline-title {
  font-family: "SF Pro Text", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif;
  font-style: normal;
  font-weight: 700;
  text-align: left;
  color: white;
  letter-spacing: 0.374px;
}
@media screen and (min-width: 0px) {
  .headline-title {
    font-size: 30px;
    line-height: 41px;
    width: 100%;
    max-width: 300px;
    padding: 30px 0 0 0;
  }
}
@media screen and (min-width: 667px) {
  .headline-title {
    font-size: 38px;
    line-height: 44px;
    width: 100%;
    max-width: 465px;
    padding: 110px 0 0 0;
  }
}
@media screen and (min-width: 900px) {
  .headline-title {
    font-size: 48px;
    line-height: 56px;
    width: 100%;
    max-width: 660px;
    padding: 120px 0 40px 0;
  }
}
@media screen and (min-width: 1200px) {
  .headline-title {
    font-size: 48px;
    line-height: 56px;
    width: 100%;
    max-width: 879px;
    padding: 120px 0 40px 0;
  }
}

.feature-list-title {
  font-family: "SF Pro Text", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif;
  font-style: normal;
  text-align: left;
  font-weight: 700;
  /* identical to box height, or 116% */
  letter-spacing: 0.374px;
  color: #FFFFFF;
}
@media screen and (min-width: 0px) {
  .feature-list-title {
    font-size: 28px;
    line-height: 33px;
  }
}
@media screen and (min-width: 667px) {
  .feature-list-title {
    font-size: 28px;
    line-height: 33px;
  }
}
@media screen and (min-width: 900px) {
  .feature-list-title {
    font-size: 34px;
    line-height: 41px;
  }
}
@media screen and (min-width: 1200px) {
  .feature-list-title {
    font-size: 38px;
    line-height: 56px;
  }
}

.available-title {
  font-family: "SF Pro Text", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif;
  font-style: normal;
  text-align: left;
  font-weight: 700;
  padding-bottom: 50px;
  /* identical to box height, or 116% */
  letter-spacing: 0.374px;
  color: #FFFFFF;
}
@media screen and (min-width: 0px) {
  .available-title {
    font-size: 28px;
    line-height: 33px;
  }
}
@media screen and (min-width: 667px) {
  .available-title {
    font-size: 28px;
    line-height: 33px;
  }
}
@media screen and (min-width: 900px) {
  .available-title {
    font-size: 34px;
    line-height: 41px;
  }
}
@media screen and (min-width: 1200px) {
  .available-title {
    font-size: 38px;
    line-height: 56px;
    width: 660px;
  }
}

.feature-list-item {
  font-family: "SF Pro Display", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif;
  font-style: normal;
  font-weight: 600;
  padding-bottom: 24px;
  font-size: 20px;
  color: #8E8E93;
  text-align: left;
  line-height: 24px;
  /* identical to box height, or 120% */
  letter-spacing: 0.38px;
  /* SystemGray/Dark */
  color: #8E8E93;
}
@media screen and (min-width: 0px) {
  .feature-list-item {
    font-size: 17px;
    line-height: 22px;
  }
}
@media screen and (min-width: 667px) {
  .feature-list-item {
    font-size: 17px;
    line-height: 22px;
  }
}
@media screen and (min-width: 900px) {
  .feature-list-item {
    font-size: 20px;
    line-height: 24px;
  }
}
@media screen and (min-width: 1200px) {
  .feature-list-item {
    font-size: 20px;
    line-height: 24px;
  }
}
.feature-list-item a {
  color: #6CE997;
  text-decoration: none;
  cursor: pointer;
}
.feature-list-item a:hover {
  text-decoration: underline;
}

.email-link {
  font-family: "SF Pro Display", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif;
  font-style: normal;
  font-weight: 600;
  padding-bottom: 24px;
  font-size: 20px;
  text-align: left;
  line-height: 24px;
  /* identical to box height, or 120% */
  letter-spacing: 0.38px;
  /* SystemGray/Dark */
}
@media screen and (min-width: 0px) {
  .email-link {
    font-size: 17px;
    line-height: 22px;
  }
}
@media screen and (min-width: 667px) {
  .email-link {
    font-size: 17px;
    line-height: 22px;
  }
}
@media screen and (min-width: 900px) {
  .email-link {
    font-size: 20px;
    line-height: 24px;
  }
}
@media screen and (min-width: 1200px) {
  .email-link {
    font-size: 20px;
    line-height: 24px;
  }
}`, "",{"version":3,"sources":["webpack://./src/Home-page.scss"],"names":[],"mappings":"AAYA;EACE,WAAA;AAXF;AAcE;EAJF;IAKI,YAAA;EAXF;AACF;AAaE;EARF;IASI,YAAA;EAVF;AACF;AAYE;EAZF;IAaI,YAAA;EATF;AACF;AAWE;EAhBF;IAiBI,aAAA;EARF;AACF;;AAWA;EACE,mBAAA;EACA,iBAAA;EACA,WAAA;AARF;;AAWA;EACE,+IAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,YAAA;EACA,uBAAA;AARF;AAUE;EARF;IASI,eAAA;IACA,iBAAA;IACA,WAAA;IACA,gBAAA;IACA,mBAAA;EAPF;AACF;AASE;EAhBF;IAiBI,eAAA;IACA,iBAAA;IACA,WAAA;IACA,gBAAA;IACA,oBAAA;EANF;AACF;AAQE;EAxBF;IAyBI,eAAA;IACA,iBAAA;IACA,WAAA;IACA,gBAAA;IACA,uBAAA;EALF;AACF;AAOE;EAhCF;IAiCI,eAAA;IACA,iBAAA;IACA,WAAA;IACA,gBAAA;IACA,uBAAA;EAJF;AACF;;AAQA;EACE,+IAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,qCAAA;EAEA,uBAAA;EAEA,cAAA;AAPF;AASE;EAXF;IAYI,eAAA;IACA,iBAAA;EANF;AACF;AAQE;EAhBF;IAiBI,eAAA;IACA,iBAAA;EALF;AACF;AAOE;EArBF;IAsBI,eAAA;IACA,iBAAA;EAJF;AACF;AAME;EA1BF;IA2BI,eAAA;IACA,iBAAA;EAHF;AACF;;AAQA;EACE,+IAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,oBAAA;EACA,qCAAA;EAEA,uBAAA;EAEA,cAAA;AAPF;AASE;EAZF;IAaI,eAAA;IACA,iBAAA;EANF;AACF;AAQE;EAjBF;IAkBI,eAAA;IACA,iBAAA;EALF;AACF;AAOE;EAtBF;IAuBI,eAAA;IACA,iBAAA;EAJF;AACF;AAME;EA3BF;IA4BI,eAAA;IACA,iBAAA;IACA,YAAA;EAHF;AACF;;AAOA;EACE,kJAAA;EACA,kBAAA;EACA,gBAAA;EACA,oBAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;EACA,iBAAA;EACA,qCAAA;EAEA,sBAAA;EAEA,oBAAA;EAEA,cAAA;AAPF;AASE;EAjBF;IAkBI,eAAA;IACA,iBAAA;EANF;AACF;AAQE;EAtBF;IAuBI,eAAA;IACA,iBAAA;EALF;AACF;AAOE;EA3BF;IA4BI,eAAA;IACA,iBAAA;EAJF;AACF;AAME;EAhCF;IAiCI,eAAA;IACA,iBAAA;EAHF;AACF;AAKE;EACE,cAAA;EACA,qBAAA;EACA,eAAA;AAHJ;AAKI;EACE,0BAAA;AAHN;;AAQA;EACE,kJAAA;EACA,kBAAA;EACA,gBAAA;EACA,oBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,qCAAA;EAEA,sBAAA;EAEA,oBAAA;AAPF;AAUE;EAfF;IAgBI,eAAA;IACA,iBAAA;EAPF;AACF;AASE;EApBF;IAqBI,eAAA;IACA,iBAAA;EANF;AACF;AAQE;EAzBF;IA0BI,eAAA;IACA,iBAAA;EALF;AACF;AAOE;EA9BF;IA+BI,eAAA;IACA,iBAAA;EAJF;AACF","sourcesContent":["\n$extra-small: 0px;\n$small: 667px;\n$medium: 900px;\n$large: 1200px;\n\n\n\n.headline-container {\n\n}\n\n.spacer {\n  width: 100%;\n\n\n  @media screen and (min-width: $extra-small) {\n    height: 20px;\n  }\n\n  @media screen and (min-width: $small) {\n    height: 30px;\n  }\n\n  @media screen and (min-width: $medium) {\n    height: 80px;\n  }\n\n  @media screen and (min-width: $large) {\n    height: 100px;\n  }\n}\n\n.headline-image {\n  object-fit: contain;\n  max-width: 1080px;\n  width: 100%;\n}\n\n.headline-title {\n  font-family: 'SF Pro Text', -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Oxygen-Sans, Ubuntu, Cantarell, \"Helvetica Neue\", sans-serif;\n  font-style: normal;\n  font-weight: 700;\n  text-align: left;\n  color: white;\n  letter-spacing: 0.374px;\n\n  @media screen and (min-width: $extra-small) {\n    font-size: 30px;\n    line-height: 41px;\n    width: 100%;\n    max-width: 300px;\n    padding: 30px 0 0 0;\n  }\n\n  @media screen and (min-width: $small) {\n    font-size: 38px;\n    line-height: 44px;\n    width: 100%;\n    max-width: 465px;\n    padding: 110px 0 0 0;\n  }\n\n  @media screen and (min-width: $medium) {\n    font-size: 48px;\n    line-height: 56px;\n    width: 100%;\n    max-width: 660px;\n    padding: 120px 0 40px 0;\n  }\n\n  @media screen and (min-width: $large) {\n    font-size: 48px;\n    line-height: 56px;\n    width: 100%;\n    max-width: 879px;\n    padding: 120px 0 40px 0;\n  }\n}\n\n\n.feature-list-title {\n  font-family: 'SF Pro Text', -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Oxygen-Sans, Ubuntu, Cantarell, \"Helvetica Neue\", sans-serif;\n  font-style: normal;\n  text-align: left;\n  font-weight: 700;\n  /* identical to box height, or 116% */\n\n  letter-spacing: 0.374px;\n\n  color: #FFFFFF;\n\n  @media screen and (min-width: $extra-small) {\n    font-size: 28px;\n    line-height: 33px;\n  }\n\n  @media screen and (min-width: $small) {\n    font-size: 28px;\n    line-height: 33px;\n  }\n\n  @media screen and (min-width: $medium) {\n    font-size: 34px;\n    line-height: 41px;\n  }\n\n  @media screen and (min-width: $large) {\n    font-size: 38px;\n    line-height: 56px;\n    //width: 660px;\n  }\n\n}\n\n.available-title {\n  font-family: 'SF Pro Text', -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Oxygen-Sans, Ubuntu, Cantarell, \"Helvetica Neue\", sans-serif;\n  font-style: normal;\n  text-align: left;\n  font-weight: 700;\n  padding-bottom: 50px;\n  /* identical to box height, or 116% */\n\n  letter-spacing: 0.374px;\n\n  color: #FFFFFF;\n\n  @media screen and (min-width: $extra-small) {\n    font-size: 28px;\n    line-height: 33px;\n  }\n\n  @media screen and (min-width: $small) {\n    font-size: 28px;\n    line-height: 33px;\n  }\n\n  @media screen and (min-width: $medium) {\n    font-size: 34px;\n    line-height: 41px;\n  }\n\n  @media screen and (min-width: $large) {\n    font-size: 38px;\n    line-height: 56px;\n    width: 660px;\n  }\n\n}\n\n.feature-list-item {\n  font-family: 'SF Pro Display', -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Oxygen-Sans, Ubuntu, Cantarell, \"Helvetica Neue\", sans-serif;\n  font-style: normal;\n  font-weight: 600;\n  padding-bottom: 24px;\n  font-size: 20px;\n  color: #8E8E93;\n  text-align: left;\n  line-height: 24px;\n  /* identical to box height, or 120% */\n\n  letter-spacing: 0.38px;\n\n  /* SystemGray/Dark */\n\n  color: #8E8E93;\n\n  @media screen and (min-width: $extra-small) {\n    font-size: 17px;\n    line-height: 22px;\n  }\n\n  @media screen and (min-width: $small) {\n    font-size: 17px;\n    line-height: 22px;\n  }\n\n  @media screen and (min-width: $medium) {\n    font-size: 20px;\n    line-height: 24px;\n  }\n\n  @media screen and (min-width: $large) {\n    font-size: 20px;\n    line-height: 24px;\n  }\n\n  a {\n    color: #6CE997;\n    text-decoration: none;\n    cursor: pointer;\n\n    &:hover {\n      text-decoration: underline;\n    }\n  }\n}\n\n.email-link {\n  font-family: 'SF Pro Display', -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Oxygen-Sans, Ubuntu, Cantarell, \"Helvetica Neue\", sans-serif;\n  font-style: normal;\n  font-weight: 600;\n  padding-bottom: 24px;\n  font-size: 20px;\n  text-align: left;\n  line-height: 24px;\n  /* identical to box height, or 120% */\n\n  letter-spacing: 0.38px;\n\n  /* SystemGray/Dark */\n\n\n  @media screen and (min-width: $extra-small) {\n    font-size: 17px;\n    line-height: 22px;\n  }\n\n  @media screen and (min-width: $small) {\n    font-size: 17px;\n    line-height: 22px;\n  }\n\n  @media screen and (min-width: $medium) {\n    font-size: 20px;\n    line-height: 24px;\n  }\n\n  @media screen and (min-width: $large) {\n    font-size: 20px;\n    line-height: 24px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
